import useAppTranslation from "@hooks/language/useAppTranslation";
import SEO from "@modules/seo/SEO";
import { Trans } from "react-i18next";
import img1 from "../assets/unlockSkin_1.webp";
import img2 from "../assets/unlockSkin_2.webp";
import img3 from "../assets/unlockSkin_3.webp";
import HelpCenterContainer from "../components/HelpCenterContainer";
import HelpCenterDiscordLink from "../components/HelpCenterDiscordLink";
import HelpCenterImage from "../components/HelpCenterImage";
import HelpCenterText from "../components/HelpCenterText";
import HelpCenterTitle from "../components/HelpCenterTitle";

const HowToUnlockSkinsWithShards = () => {
  const { t } = useAppTranslation("pages.helpCenter");

  return (
    <>
      <SEO
        title={t("unlockSkins.seo.title")}
        description={t("unlockSkins.seo.description")}
      />
      <HelpCenterContainer title={t("unlockSkins.title")}>
        <HelpCenterText>{t("unlockSkins.intro")}</HelpCenterText>

        <HelpCenterTitle>{t("unlockSkins.step1.title")}</HelpCenterTitle>

        <HelpCenterText>{t("unlockSkins.step1.text")}</HelpCenterText>

        <HelpCenterImage src={img1} />

        <HelpCenterTitle>{t("unlockSkins.step2.title")}</HelpCenterTitle>

        <HelpCenterText>{t("unlockSkins.step2.text")}</HelpCenterText>

        <HelpCenterImage src={img2} />

        <HelpCenterTitle>{t("unlockSkins.step3.title")}</HelpCenterTitle>

        <HelpCenterText>
          <Trans i18nKey="pages.helpCenter.unlockSkins.step3.text">
            Pour déverrouiller le skin, cliquez dessus, puis utilisez le bouton
            "<b>Upgrade to Skin Permanent</b>".
            <b>Remarque</b> : vous devrez probablement d'abord désenchanter les
            autres fragments en essence, afin d'en avoir suffisamment pour
            débloquer le skin désiré.
          </Trans>
        </HelpCenterText>

        <HelpCenterImage src={img3} className="md:min-w-[50%]" />

        <HelpCenterTitle>{t("common.conclusion")}</HelpCenterTitle>

        <HelpCenterText>
          <Trans i18nKey="pages.helpCenter.unlockSkins.conclusion.text">
            Débloquer des skins à partir d'éclats de skins est une manière
            exciting et accessible d'améliorer votre expérience sur League of
            Legends. Si vous rencontrez des problèmes ou avez des questions
            supplémentaires, n'hésitez pas à nous contacter via notre{" "}
            <HelpCenterDiscordLink />.
          </Trans>
        </HelpCenterText>
      </HelpCenterContainer>
    </>
  );
};

export default HowToUnlockSkinsWithShards;
